import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BothSideVisibleScrollbars } from "../../../../Constant";
import { H6, P } from "../../../../AbstractElements";
import ScrollBar from "react-perfect-scrollbar";
import { BOTH_SIDE_SCROLL } from "../../../../Data/Bonus Ui/Scrollable";

const BothSideVisibleScrollbar = () => {
  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={BothSideVisibleScrollbars} span={BOTH_SIDE_SCROLL} />
        <CardBody>
          <div className="scroll-bar-wrap">
            <ScrollBar className="scroll-demo" style={{width:"100%", height:"300px"}}>
              <div className="horz-scroll-content">
                <Row>
                  <Col sm="4">
                    <P className="pt-3">Inspiration can take many different forms, and <em className="txt-danger">professional growth never stops</em>. In light of this, we've compiled a comprehensive list of web design blogs that will keep your mind stimulated for the entire year. You won't find any stinkers on this list, so don't worry. We value your time and believe that you should only receive the greatest. Because of this, we've only gathered web design blogs that have recently being updated. Get ready to add numerous subscriptions by creating your Feebly account.<br />{`-->`} Responsive...<br />{`-->`} Secure your domain...<br />{`-->`} Testing...<br />{`-->`} Content creation...<br />{`-->`} Visual elements...<br />{`-->`} Launch...</P>
                  </Col>
                  <Col sm="4">
                    <H6 className="pb-2">Latest trends </H6>
                    <P>You should stay current with all the most recent advances in the business whether you operate as a freelance web designer or for an agency or design studio. You may be sure you're constantly providing the most intelligent and original design solutions by doing this.</P>
                    <P>You can keep up with evolving design trends by reading web design blogs. You'll need to be able to comprehend new trends' causes and how they affect user experience. Additionally, you'll discover upgrades to current tools as well as new ones that have recently hit the market.</P>
                  </Col>
                  <Col sm="4">
                    <H6 className="pb-2">How to make best website ideas </H6>
                    <P className="pt-3">{`-->`} Blog <br />{`-->`} Portfolio website <br />{`-->`}Event website <br />{`-->`} personal website <br />{`-->`} Fashion website <br />{`-->`} Admin dashboards <br />{`-->`} E-commerce website <br />{`-->`} Beauty website <br />{`-->`} Food website<br />{`-->`} Animation website <br />{`-->`} Financial website</P>
                  </Col>
                </Row>
              </div>
            </ScrollBar>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BothSideVisibleScrollbar;
